/**
 * Lo que suena en el mundo al tocar a alguien o algo que no es Alpha: Sócrates y la Nave.
 *
 * POR QUÉ ES UN FICHERO Y NO TRES MÉTODOS MÁS EN `sound.js`. Allí cada sonido tiene que ser un
 * método que pregunte por su canal —lo vigila `prueba_canales.mjs`, y está bien que lo vigile—,
 * pero `sound.js` estaba a nueve líneas del trinquete de las 400. Así que allí se queda lo que
 * decide (el nombre y la guarda) y aquí lo que suena (las notas). Es el mismo trato que ya
 * tenía la voz de Alpha con `vozAlpha.mjs`.
 *
 * Y EL RUIDO FILTRADO SE MUDÓ AQUÍ también, y con barrido: `_noise` era un primitivo de veinte
 * líneas que sólo sabía sonar a una frecuencia, y el despegue necesita que el filtro suba.
 * `sound.js` le sigue llamando igual —mismos cuatro argumentos, mismo sonido—.
 *
 * `s` es la instancia de `sound`: se usan sus `_tone` y su `AudioContext`, así que todo esto
 * respeta el silencio y comparte el reproductor con el resto de la casa.
 */

/** Ruido que se apaga, pasado por un filtro que puede ir de `desde` a `hasta`. */
export function ruido(ctx, { dur = 0.15, desde = 1000, hasta = null, gain = 0.06, tipo = "bandpass",
  when = 0, q = null } = {}) {
  if (!ctx) return;
  const t0 = ctx.currentTime + when;
  const size = Math.floor(ctx.sampleRate * dur);
  const buffer = ctx.createBuffer(1, size, ctx.sampleRate);
  const data = buffer.getChannelData(0);
  for (let i = 0; i < size; i++) data[i] = (Math.random() * 2 - 1) * (1 - i / size);
  const src = ctx.createBufferSource();
  src.buffer = buffer;
  const filtro = ctx.createBiquadFilter();
  filtro.type = tipo;
  filtro.frequency.setValueAtTime(desde, t0);
  if (hasta) filtro.frequency.exponentialRampToValueAtTime(hasta, t0 + dur);
  if (q != null) filtro.Q.value = q;
  const g = ctx.createGain();
  g.gain.setValueAtTime(gain, t0);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  src.connect(filtro).connect(g).connect(ctx.destination);
  src.start(t0);
}

// AQUÍ SONABA LA LIRA DE SÓCRATES al tocarlo, y se quitó el 29 de octubre de 2026: *«la lira de
// Sócrates no debe sonar, habla Sócrates»*. Ahora dice una de sus frases (`dicenLosPersonajes.js`).

/**
 * LA CABINA, al abrirse: el soplido de la compuerta y los dos pitidos del panel. Suena cuando
 * se pregunta si despegas, no al andar por el casco: el casco es suelo, y el suelo no pita.
 */
export function compuerta(s) {
  ruido(s._ensure(), { dur: 0.45, desde: 5200, hasta: 1800, gain: 0.09, tipo: "highpass" });
  s._tone({ freq: 1318.5, type: "sine", dur: 0.09, gain: 0.09, when: 0.18 });
  s._tone({ freq: 1760, type: "sine", dur: 0.14, gain: 0.09, when: 0.3 });
}

/**
 * EL DESPEGUE: los motores cogiendo vueltas —un zumbido que sube dos octavas— y el aire que se
 * abre por encima. Suena al elegir rumbo, justo antes de cambiar de pantalla; el contexto de
 * audio es el mismo en toda la aplicación, así que no se corta al navegar.
 */
export function despegue(s) {
  s._tone({ freq: 55, to: 220, type: "sawtooth", dur: 1.4, gain: 0.063 });
  s._tone({ freq: 110, to: 440, type: "triangle", dur: 1.4, gain: 0.09 });
  s._tone({ freq: 220, to: 1320, type: "sine", dur: 1.2, gain: 0.054, when: 0.35 });
  ruido(s._ensure(), { dur: 1.5, desde: 300, hasta: 3800, gain: 0.09, q: 4 });
}
